import React from 'react'
import Participants from './Participants'
import PaymentMethods from './PaymentsMethods'
import SectionHeading from './SectionHeading'
import ReservationBox from './ReservationBox'
import InfoPink from '@assets/img/reservation/info-pink.svg'
import { useReservationContext } from './ReservationContext'

const PaymentView = ({
    readOnlyChoices = false,
    allowPromotionChanges = false,
}) => {
    const {
        form,
        errors,
        paymentMethod,
        setPaymentMethod,
        masterCheckbox,
        handleMasterCheckboxChange,
        handleAgreementChange,
        userData,
        useCashbackForPay,
        setUseCashbackForPay,
        earnedCashbackAmount,
        cashbackRedemptionEnabled,
        promotionCodeInput,
        setPromotionCodeInput,
        promotionCodes,
        promotionPreview,
        promotionError,
        addPromotionCode,
        removePromotionCode,
        t
    } = useReservationContext()

    const canEditPromotions = !readOnlyChoices || allowPromotionChanges

    return (
        <div className="trip-reservation__section">
            {Object.keys(errors).length !== 0 && (
                <div className="trip-reservation__error-announcement">
                    <img src={InfoPink} alt="info" />
                    {Object.values(errors).map((err, index) => (
                        <div key={index}>{err}</div>
                    ))}
                </div>
            )}
            <SectionHeading headingText={t('payments')} subheaderText={t('summary')} />
            <div className="trip-reservation__small-heading">{t('participants-data')}</div>
            <Participants form={form} t={t} />

            {cashbackRedemptionEnabled && userData && Number(userData.cashbackBalance) > 0 && (
                <ReservationBox headerText={t('select-payment-with-cashback')}>
                    <label className="trip-reservation__payment-method trip-reservation__payment-method--cashback">
                        <input
                            type="checkbox"
                            name="useCashback"
                            checked={useCashbackForPay}
                            disabled={readOnlyChoices}
                            onChange={
                                readOnlyChoices
                                    ? undefined
                                    : () => setUseCashbackForPay(!useCashbackForPay)
                            }
                        />
                        <span className="trip-reservation__payment-method-radio-checkmark"></span>
                        <div className="trip-reservation__payment-method-name">VacationClub Cashback</div>
                        <div className="trip-reservation__payment-method-desc">{t('use-cashback')}</div>
                        <div className="trip-reservation__payment-method-icon trip-reservation__payment-method-icon--paypal">
                            {userData.cashbackBalance} PLN
                        </div>
                    </label>
                </ReservationBox>
            )}

            <ReservationBox headerText={t('voucher-label')}>
                {canEditPromotions && (
                    <div className="trip-reservation__promo-input-row">
                        <input
                            className="trip-reservation__input trip-reservation__input--wide"
                            placeholder={t('enter-code')}
                            value={promotionCodeInput}
                            onChange={(event) =>
                                setPromotionCodeInput(event.target.value)
                            }
                        />
                        <button
                            type="button"
                            className="trip-reservation__btn trip-reservation__promo-add-btn"
                            onClick={addPromotionCode}
                        >
                            {t('add-code')}
                        </button>
                    </div>
                )}
                {promotionCodes.length > 0 && (
                    <div className="trip-reservation__promo-list">
                        {promotionCodes.map((code) => (
                            <div className="trip-reservation__promo-item" key={`discount-${code}`}>
                                <span>{code}</span>
                                {canEditPromotions && (
                                    <button
                                        type="button"
                                        className="trip-reservation__promo-remove"
                                        onClick={() => removePromotionCode(code)}
                                    >
                                        {t('remove-code')}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {promotionPreview && (
                    <div className="trip-reservation__promo-summary">
                        {Number(promotionPreview.discountAmountTotal || 0) > 0 && (
                            <div>
                                <span>{t('discount')}</span>
                                <strong>-{Number(promotionPreview.discountAmountTotal).toFixed(2)} PLN</strong>
                            </div>
                        )}
                        {Number(promotionPreview.giftVoucherAmountTotal || 0) > 0 && (
                            <div>
                                <span>{t('gift-voucher-label')}</span>
                                <strong>-{Number(promotionPreview.giftVoucherAmountTotal).toFixed(2)} PLN</strong>
                            </div>
                        )}
                    </div>
                )}
                {promotionError && (
                    <div className="trip-reservation__error">
                        {promotionError}
                    </div>
                )}
            </ReservationBox>

            <ReservationBox headerText={t('select-payment-method')}>
                <PaymentMethods
                    paymentMethod={paymentMethod}
                    setPaymentMethod={setPaymentMethod}
                    hasError={errors.payment_method}
                    t={t}
                />
                {errors.payment_method ? (
                    <div className="trip-reservation__error">{errors.payment_method[0]}</div>
                ) : null}
            </ReservationBox>

            <div>
                <label className="trip-reservation__checkbox-wrapper trip-reservation__checkbox-wrapper--master">
                    {t('accept-all-consents')}
                    <input type="checkbox" checked={masterCheckbox} onChange={handleMasterCheckboxChange} />
                    <span className="trip-reservation__checkbox-checkmark"></span>
                </label>
                <div className="trip-reservation__agreements-list">
                    {form.agreements.map((agreement, index) => (
                        <label className="trip-reservation__checkbox-wrapper" key={agreement.id}>
                            <span
                                dangerouslySetInnerHTML={{ __html: agreement.label }}
                                className="trip-reservation__checkbox-label-text"
                            ></span>
                            {agreement.required ? '*' : null}
                            <input
                                id={index}
                                type="checkbox"
                                name="agreements[]"
                                value={agreement.id}
                                checked={agreement.checked}
                                onChange={(e) => handleAgreementChange(index, e.target.checked)}
                                required={agreement.required}
                            />
                            <span className="trip-reservation__checkbox-checkmark"></span>
                        </label>
                    ))}
                </div>
                <div className="trip-reservation__required-checkboxes">*{t('required-field')}</div>
            </div>
        </div>
    )
}

export default PaymentView
